var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTextDecor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 82,
    viewBox: "0 0 78 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.225 62.1269C40.9445 58.3911 47.5895 54.4298 54.1291 50.4776C49.8865 49.3294 45.7457 48.79 41.3206 48.3338C42.066 45.1072 41.9519 39.9569 41.2897 36.7321C36.3307 36.9186 32.2896 37.4795 27.5388 38.3923C26.9125 35.1217 25.926 32.1778 24.3559 29.1297C20.2458 34.4851 16.5795 40.037 13.2728 45.7773C16.256 47.7215 19.3389 48.9321 22.2042 51.0142C27.1285 54.5918 30.2963 57.7057 34.225 62.1269Z",
    stroke: "url(#paint0_linear_78_3295)",
    strokeWidth: 4.22397,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5674 14.9656C17.2905 16.6178 17.9454 18.2976 18.707 19.937",
    stroke: "white",
    strokeWidth: 4.23413,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4287 15.0381C44.3278 16.7595 43.3878 18.5487 42.3173 20.2823",
    stroke: "white",
    strokeWidth: 4.23413,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5838 35.0084C60.6848 34.5695 63.7233 33.865 66.822 33.4198",
    stroke: "white",
    strokeWidth: 4.23413,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0739 60.0832C62.8883 61.2106 65.732 62.3946 68.6568 63.3051",
    stroke: "white",
    strokeWidth: 4.23413,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_78_3295",
    x1: 18.5109,
    y1: 34.5868,
    x2: 28.3286,
    y2: 63.3145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515056,
    stopColor: "#A070FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB35C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextDecor);
export default __webpack_public_path__ + "static/media/text-decor.773f8fb60879ed8f33e500aad842476e.svg";
export { ForwardRef as ReactComponent };